<template>

  <div class="height-100">
    <Unavailable
      v-if="unavailable"
      title="Gerenciamento de requisições"
      class="height-100" />
    <div
      v-if="!unavailable"
      class="vflex">
      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>{{ $t('Requisitions') }}</h4>
          </div>
          <div class="btn-row">
            <div class="btn-group">
              <button
                class="btn"
                :class="type==='all' ? 'btn-secondary' : 'btn-light'"
                type="button"
                @click="changeType('all')">
                {{ $t('All') }}
              </button>
              <button
                class="btn"
                :class="type==='mine' ? 'btn-secondary' : 'btn-light'"
                type="button"
                @click="changeType('mine')">
                {{ $t('Mine') }}
              </button>
            </div>
            <button
              class="btn"
              :class="type==='needs_approval' ? 'btn-secondary' : 'btn-light'"
              type="button"
              @click="openPendingApprovals()">
              {{ $t('Need approval') }}
            </button>
            <button
              v-if="permissions.includes('manage_requisitions')"
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New requisition') }}
              </button>
          </div>
        </div>
      </div>

      <div class="vflex-row-1">
        <filterfy
          :models="filtersMap"
          :initFilters="filters"
          @changed="setFilters">
          <Paginaty
            :total="paginate.total"
            :pages="paginate.pages"
            :page="paginate.page"
            :creating="creating"
            :loading="loading"
            @changePage="setPage">
            
            <template slot="content">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th-sort
                      field="title"
                      :value="sort"
                      @input="setSort">{{ $t('Title') }}</th-sort>
                    <th-sort
                      field="openings"
                      :value="sort"
                      @input="setSort">{{ $t('Approval flow') }}</th-sort>
                    <th-sort
                      field="openings"
                      :value="sort"
                      @input="setSort">{{ $t('Openings') }}</th-sort>
                    <th-sort
                      field="hiring_manager_name"
                      :value="sort"
                      @input="setSort">{{ $t('Hiring manager') }}</th-sort>
                    <th-sort
                      field="departament_id"
                      :value="sort"
                      @input="setSort">{{ $t('Department') }}</th-sort>
                    <th-sort
                      field="company_id"
                      :value="sort"
                      @input="setSort">{{ $t('Company') }}</th-sort>
                    <th-sort
                      field="job"
                      :value="sort"
                      @input="setSort">{{ $t('Job') }}</th-sort>
                    <th-sort
                      field="created_at"
                      :value="sort"
                      @input="setSort">{{ $t('Created at') }}</th-sort>
                    <th-sort
                      field="owner_user_id"
                      :value="sort"
                      @input="setSort">{{ $t('Owner') }}</th-sort>
                  </tr>
                </thead>
                <tbody>
                  <RequisitionListItem
                    v-for="(requisition, index) in requisitions"
                    :key="index"
                    :requisition="requisition" />
                </tbody>
              </table>
            </template>
            <template slot="noresults">
              {{ $t('There are no items') }}
            </template>
          </Paginaty>
        </filterfy>
      </div>

      <div
        class="vflex-row-0"
        v-if="modal_select">
        <requisition-form 
          :initRequisition="modal_select" 
          @hideModal="hideModal()" 
          @deleted="loadData(); hideModal()" 
          @saved="redirectToRequisition" >
          </requisition-form>
      </div>
    </div>
  </div>

</template>

<script>
import RequisitionForm from '@/components/RequisitionForm/RequisitionForm'
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import RequisitionListItem from './RequisitionListItem'
import Unavailable from '../Unavailable/Unavailable'

export default {
  name: 'RequisitionList',
  components: {
    RequisitionForm,
    Filterfy,
    ThSort,
    Paginaty,
    RequisitionListItem,
    Unavailable
  },
  data () {
    return {
      unavailable: false,
      creating: true,
      loading: true,
      type: 'all',
      modal_select: false,
      is_template: false,
      filtersMap: [
        {
          'type': 'keyword',
          'label': this.$t('Title'),
          'target': 'title'
        },
        {
          'type': 'keyword',
          'label': this.$t('Hiring manager'),
          'target': 'hiring_manager_name'
        },
        {
          'type': 'list',
          'label': this.$t('Status'),
          'target': 'status',
          'resource': 'requisition_status'
        },
        {
          'type': 'list',
          'label': this.$t('Owner'),
          'target': 'owner_user_id',
          'resource': 'users'
        },
        {
          'type': 'list',
          'label': this.$t('Departaments'),
          'target': 'departament_id',
          'resource': 'departaments'
        },
        {
          'type': 'list',
          'label': this.$t('Companies'),
          'target': 'company_id',
          'resource': 'companies'
        }
      ]
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    requisitions () {
      return this.$store.getters.getRequisitions
    },
    paginate () {
      return this.$store.getters.getRequisitionsPaginate
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-created_at'
    }
  },
  metaInfo () {
    return {
      title: this.$t('Requisitions')
    }
  },
  created () {
    if (!this.filters.status) {
      this.$changeUrlParam({status: ['analyzing']})
    }
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        type: this.type,
        template: false,
        page: this.$route.query.page,
        sort: this.sort,
        limit: this.$default.limit // ,
        // template: this.is_template
      }

      this.$store
      .dispatch('selectRequisitions', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.setPage(1)
        this.loading = this.creating = false
      }).catch(err => {
        this.unavailable = err.response && err.response.data && err.response.data.name === 'UpgradeRequired'
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    redirectToRequisition
    */
    redirectToRequisition (requisition) {
      this.$router.push('/requisition/' + requisition._id)
    },
    changeType (type) {
      this.type = type
      this.loadData()
    },
    openPendingApprovals () {
      this.$changeUrlParam({
        approvals: true,
        approvals_type: 'requisition'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card-container{
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequisitionList/RequisitionList.vue